import { render, staticRenderFns } from "./ViewMethodDataCollection.vue?vue&type=template&id=093dd155&"
import script from "./ViewMethodDataCollection.vue?vue&type=script&lang=js&"
export * from "./ViewMethodDataCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports